import { gql } from '@apollo/client';

const TICKET_FIELDS = `
  vst_id
  vst_type
  vst_marketplaces
  vst_subject
  vst_owner_initials
  vst_owners
  vst_contact_email
  vst_contact_name
  vst_user_id
  vst_event_id
  vst_status
  vst_opened_at
  vst_completed_at
  vst_reopen_count
  vst_open_seconds_total
  vst_current_open_since
  vst_event_name
  vst_event_date
  vst_pid
  vst_section
  vst_row
  vst_seats
  vst_last_message_at
  vst_last_inbound_at
  vst_unread_count
  vst_sync_accounts
`;

export const GET_VL_SUPPORT_TICKETS = gql`
  query GetVlSupportTickets($where: vl_support_ticket_bool_exp!, $scope: vl_support_ticket_bool_exp!, $completedSince: timestamptz!, $limit: Int!, $offset: Int!) {
    vl_support_ticket(where: $where, order_by: [{ vst_unread_count: desc }, { vst_last_message_at: desc_nulls_last }], limit: $limit, offset: $offset) {
      ${TICKET_FIELDS}
    }
    vl_support_ticket_aggregate(where: $where) {
      aggregate { count }
    }
    open: vl_support_ticket_aggregate(where: { _and: [$scope, { vst_status: { _eq: "open" } }] }) {
      aggregate { count }
    }
    completed: vl_support_ticket_aggregate(where: { _and: [$scope, { vst_status: { _eq: "completed" } }, { vst_completed_at: { _gte: $completedSince } }] }) {
      aggregate { count }
    }
  }
`;

/** One user's listings that have a support request: which support tickets they belong to, and the listing's status. */
export const GET_USER_SUPPORT_SCOPE = gql`
  query GetUserSupportScope($userId: uuid!) {
    getmanageticket(where: { u_id: { _eq: $userId }, vl_support_requests: {} }) {
      tp_id
      tp_status
      vl_support_requests {
        vsr_ticket_id
      }
    }
    linked: vl_support_ticket(where: { vst_user_id: { _eq: $userId } }) {
      vst_id
    }
  }
`;

/** The users whose listings each support ticket was raised on. */
export const GET_VL_SUPPORT_TICKET_USERS = gql`
  query GetVlSupportTicketUsers($ids: [uuid!]!) {
    getmanageticket(where: { vl_support_requests: { vsr_ticket_id: { _in: $ids } } }) {
      u_id
      u_first_name
      u_last_name
      vl_support_requests(where: { vsr_ticket_id: { _in: $ids } }) {
        vsr_ticket_id
      }
    }
  }
`;

/** Names for users linked to tickets by hand. */
export const GET_USERS_BY_IDS = gql`
  query GetSupportUsersByIds($ids: [uuid!]!) {
    user(where: { u_id: { _in: $ids } }) {
      u_id
      u_first_name
      u_last_name
    }
  }
`;

export const SEARCH_USERS_FOR_LINK = gql`
  query SearchUsersForSupportLink($where: user_bool_exp!) {
    user(where: $where, order_by: { u_full_name: asc }, limit: 8) {
      u_id
      u_full_name
      u_email_id
    }
  }
`;

export const SEARCH_EVENTS_FOR_LINK = gql`
  query SearchEventsForSupportLink($where: events_bool_exp!) {
    events(where: $where, order_by: { e_date: desc }, limit: 8) {
      e_id
      e_name
      e_date
      e_time_zone
    }
  }
`;

export const GET_VL_SUPPORT_TICKET_THREAD = gql`
  query GetVlSupportTicketThread($id: uuid!) {
    vl_support_ticket_by_pk(vst_id: $id) {
      ${TICKET_FIELDS}
      messages(order_by: { vsm_sent_at: asc }) {
        vsm_id
        vsm_direction
        vsm_from
        vsm_to
        vsm_subject
        vsm_body_text
        vsm_sent_at
        vsm_sent_by_email
        vsm_owner_initials
      }
      events(order_by: { vste_created_at: asc }) {
        vste_id
        vste_type
        vste_actor_email
        vste_created_at
      }
    }
  }
`;

export const GET_VL_SUPPORT_UNREAD = gql`
  query GetVlSupportUnread {
    vl_support_ticket(
      where: {
        _or: [
          { vst_unread_count: { _gt: 0 } }
          { _and: [{ vst_status: { _eq: "open" } }, { vst_last_inbound_at: { _is_null: false } }] }
        ]
      }
      order_by: { vst_last_inbound_at: desc_nulls_last }
      limit: 500
    ) {
      vst_id
      vst_subject
      vst_status
      vst_event_name
      vst_owner_initials
      vst_unread_count
      vst_last_inbound_at
      vst_last_message_at
    }
  }
`;
